/* eslint-disable prettier/prettier */
/* eslint-disable no-negated-condition */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { StackCompat as Stack, LabelCompat as Label } from 'components/FluentUICompat';
import { getTheme, mergeStyles } from 'components/FluentUICompat';
import { useEditMatkonParagraphsFormTranslations } from 'features/RegulatoryDocuments/components/DocumentDetails/EditParagraphsForm/editParagraphsFormTranslationHooks';

const theme = getTheme();
const { palette } = theme;

const containerClass = mergeStyles({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  borderRadius: '20px',
  cursor: 'pointer',
  height: '32px',
  width: '240px',
  backgroundColor: palette.neutralLight,
  position: 'relative',
});

const toggleThumbClass = mergeStyles({
  position: 'absolute',
  height: '32px',
  width: '80px',
  backgroundColor: palette.themePrimary,
  borderRadius: '20px',
  transition: 'left 0.3s',
});

const toggleLabelClass = mergeStyles({
  flex: '1 1 33%',
  textAlign: 'center',
  lineHeight: '32px',
  zIndex: 1,
  fontWeight: 'bold',
  cursor: 'pointer',
});

const inlineLabelClass = mergeStyles({
  marginRight: '10px',
  fontWeight: 'bold',
  paddingTop: '10px',
  minWidth: '300px',
});

interface ThreeStateToggleProps {
  label: string;
  onChange?: (value: boolean | null) => void;
  value?: boolean | null;
}

const ThreeStateToggle: React.FC<ThreeStateToggleProps> = ({ label, onChange, value = false  }) => {
  const [state, setState] = useState<boolean | null>(value);
  const {t} = useEditMatkonParagraphsFormTranslations();
  const getThumbPosition = () => {
    if (state === true) {
      return '0%';
    }
    if (state === null) {
      return '33%';
    }
    return '66%'; // state === false
  };

  const handleClick = (newState: boolean | null) => {
    setState(newState);
    if (onChange) {
      onChange(newState);
    }
  };

  return (
    <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 10 }} styles={{ root: { paddingTop: '10px' } }}>
      <Label className={inlineLabelClass}>{label}</Label>
      <div className={containerClass}>
        <div
          className={toggleThumbClass}
          style={{ left: getThumbPosition() }}
        />
        <div
          className={mergeStyles(toggleLabelClass, { color: state === true ? palette.white : palette.neutralDark })}
          onClick={() => handleClick(true)}
        >
          {t('Yes')}
        </div>
        <div
          className={mergeStyles(toggleLabelClass, { color: state === null ? palette.white : palette.neutralDark })}
          onClick={() => handleClick(null)}
        >
          {t('Calculated')}
        </div>
        <div
          className={mergeStyles(toggleLabelClass, { color: state === false ? palette.white : palette.neutralDark })}
          onClick={() => handleClick(false)}
        >
          {t('No')}
        </div>
      </div>
    </Stack>
  );
};

ThreeStateToggle.propTypes = {
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func,
};

export default ThreeStateToggle;
